import React, { Component } from "react";
import { Button, Card, Icon, Input, Form, Message } from "semantic-ui-react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";

import { imagePlugin } from "../Editor";

class ImagePickerButton extends Component {
  onMouseDown = event => event.preventDefault();
  onClick = () => this.props.onOverrideContent(ImageUploader);
  render() {
    return (
      <div onMouseDown={this.onMouseDown} style={{ display: "inline-block" }}>
        <Button icon="image" onClick={this.onClick} />
      </div>
    );
  }
}

class ImagePicker extends Component {
  state = {
    file: undefined,
    src: undefined,
    alt: ""
  };
  uploadImage = () => {
    this.props.client
      .mutate({
        mutation: UPLOAD_FILE_MUTATION,
        variables: { file: this.state.file }
      })
      .then(({ data }) => {
        this.setState({ src: data.uploadFile.url }, () => {
          this.props.setEditorState(
            imagePlugin.addImage(this.props.getEditorState(), this.state.src, {
              alt: this.state.alt
            })
          );
          this.setState(
            { file: undefined, src: undefined, alt: "" },
            this.close
          );
        });
      });
  };
  changeFile = event => this.setState({ file: event.target.files[0] });
  changeAltText = (event, { value: alt }) => this.setState({ alt });
  openFilePicker = () => this.filePicker.click();
  close = () => this.props.onOverrideContent();

  render() {
    console.log(this.props);
    return (
      <Message>
        <Form.Group>
          {this.state.file && this.state.alt ? (
            <Button icon onClick={this.uploadImage}>
              <Icon name="upload" />
            </Button>
          ) : (
            <Button icon onClick={this.close}>
              <Icon name="close" />
            </Button>
          )}

          <Form.Input type="file" accept="image/*" onChange={this.changeFile}>
            <Input
              action={{ icon: "image", onClick: this.openFilePicker }}
              actionPosition="left"
              placeholder="add image"
              onClick={this.openFilePicker}
              value={this.state.file ? this.state.file.name : ""}
            />
            <input
              ref={element => (this.filePicker = element)}
              style={{ display: "none" }}
            />
          </Form.Input>
          <Form.Input
            type="text"
            onChange={this.changeAltText}
            value={this.state.alt}
            placeholder="text for screen reader"
          />
        </Form.Group>
      </Message>
    );
  }
}
export const ImageUploader = withApollo(ImagePicker);

const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      url
    }
  }
`;

export default ImagePickerButton;



// WEBPACK FOOTER //
// ./src/pages/Contents/New/EditorButtons/ImagePickerButton.js